

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Divider, Modal, Tabs } from 'antd';
import dayjs from 'dayjs';
import { CheckOutlined } from '@ant-design/icons';
import can from '../../../../components/ability';

const iconStyle = {
    fontSize: 28,
}


function CardShow(props) {
    const { data, choose, onClick } = props;

    const {
        title, type, description,triggerAmount, offerAmount, startTime,endTime
    } = data;
    return (
        <div className={`dialog-info-item-coupon ${choose?'choose':''}`} onClick={() => onClick(data)}>
            <div className='choose-text'>{title}</div>
            <div>优惠券类型：{type === 1 ? '代金券' : '折扣券'}</div>
            <div style={{color: '#999'}}>备注：{description || ''}</div>
            <div>
                优惠内容：
                <span style={{color: 'red'}}>
                    满{triggerAmount / 100}元{type===1 ? '减': '折扣'}{type===1 ? offerAmount / 100 : offerAmount}{type===1 ? '元': '%'}
                </span>
            </div>
            <div>活动时间：{dayjs(startTime).format('YYYY-MM-DD HH:mm')} ~ {endTime ? dayjs(endTime).format('YYYY-MM-DD HH:mm') : '无结束日期'}</div>
            {choose?<CheckOutlined className='chose-icon' />: null}
        </div>
    )
}

export default (props) => {
    
    const { value, onChange, onClose, multi = true, visible, list = [] } = props;
    const [chooseList, setChooseList] = useState([]);
    useEffect(() => {
        let list = [];
        if (!value || value.length <= 0) {
            setChooseList([]);
            return;
        }
        if (Array.isArray(value)) {
            if (multi) {
                list = value;
            } else {
                list = [value[0]];
            }
        } else {
            list = [value];
        }
        setChooseList(list);
        return;
    }, [value, visible]);

    function onClickOne(data) {
        const id = data.couponTmpId;
        if (!multi) {
            setChooseList([id])
            return;
        }
        const index = chooseList.indexOf(id);
        let list  = []
        if (index >= 0) {
            chooseList.splice(index, 1)
        } else {
            chooseList.push(id);
        }
        list = [...chooseList];
        setChooseList(list);
    }

    function handleOk() {
        onChange(chooseList)
    }

    
    return (
        <div>
            <Modal
                title="选择优惠券"
                open={visible}
                onOk={handleOk}
                onCancel={onClose}
            >
              <div className='dialog-show-item-content'>
                {
                    list.map(i => <CardShow key={i.couponTmpId} data={i} choose={chooseList.indexOf(i.couponTmpId) >= 0} onClick={onClickOne} />)
                }
              </div>
            </Modal>
        </div>
    );
};